const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-new-nav-menu'] = {
        c: () => require('partner/modules/cus-new-nav-menu/cus-new-nav-menu.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-new-nav-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-new-nav-menu'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };